import React from 'react'
import useMobile from '../../hooks/useMobile'
import InvoiceRecords from './InvoiceRecords'
import InvoiceRecordsMobileView from './components/InvoiceRecordsMobileView'

/**
 * Common entry point for Invoice Records page
 * Routes to mobile or desktop view based on screen size
 */
const InvoiceRecordsIndex = () => {
  const isMobile = useMobile()

  return isMobile ? <InvoiceRecordsMobileView /> : <InvoiceRecords />
}

export default InvoiceRecordsIndex
